import { render, staticRenderFns } from "./exam2.vue?vue&type=template&id=303ac458&scoped=true&"
import script from "./exam2.vue?vue&type=script&lang=js&"
export * from "./exam2.vue?vue&type=script&lang=js&"
import style0 from "./exam2.vue?vue&type=style&index=0&id=303ac458&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ac458",
  null
  
)

export default component.exports